export const  CRMCampaignsData = [ {
    card1up1: "50",
    card1up2: "so far",
    card1up3: "increased by 5% since last month",
    card1dnP: "TOTAL CAMPAIGNS",
  },
  {
    card1up1: "12",
    card1up2: "ongoing",
    card1up3: "increased by 10% since last month",
    card1dnP: "ACTIVE CAMPAIGNS",
  },
];
